import React from "react";

const ChevronRightLarge: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    fill="none"
    {...props}
    viewBox="0 0 17 29"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.46.558A1.678 1.678 0 012.877.473L17 14.017 2.92 28.485a1.678 1.678 0 01-2.419 0 1.792 1.792 0 010-2.485l11.576-11.896L.543 3.042A1.792 1.792 0 01.46.558z"
    />
  </svg>
);

export default ChevronRightLarge;
